import React, { Dispatch, useState } from "react";
import { createPortal } from "react-dom";

export const ModalContext = React.createContext<{
  modal: React.ReactElement | null;
  setModal: Dispatch<React.ReactElement | null>;
} | null>(null);

export const ModalProvider = ({ children }: React.PropsWithChildren) => {
  const [modal, setModal] = useState<React.ReactElement | null>(null);
  return (
    <ModalContext.Provider
      value={{
        modal,
        setModal,
      }}
    >
      {children}
      {modal !== null ? createPortal(modal, document.body) : null}
    </ModalContext.Provider>
  );
};
